import { queryOptions, useQuery } from "@tanstack/react-query";
import {
  BrandClubForBrandPublic,
  getBrandClubForBrandPublic,
} from "../graphql/brandclub";
import { CachedQueryKeys } from "./cachedQueryKeys";
import { CampaignType } from "@brandclub/common-ui";
import { BCQueryOptions } from "./types";

export const brandClubForBrandPublicQueryOptions = (
  brandId: number | undefined
) => {
  return queryOptions({
    queryKey: [CachedQueryKeys.BrandClub],
    queryFn: ({ signal }) => {
      if (brandId == null) {
        throw new Error(
          "Brand ID is required to fetch brand club for brand public"
        );
      }
      return getBrandClubForBrandPublic(brandId, signal);
    },
    enabled: !!brandId,
  });
};

export const useBrandclubJoinReward = (
  brandId: number | undefined,
  options?: BCQueryOptions<
    typeof brandClubForBrandPublicQueryOptions,
    BrandClubForBrandPublic,
    number
  >
) => {
  return useQuery({
    ...brandClubForBrandPublicQueryOptions(brandId),
    ...options,
    select: (brandClub) => {
      const campaign = brandClub?.campaignRewards?.find(
        (reward) =>
          reward?.campaignType === CampaignType.MembershipRewardCampaign
      );
      return campaign?.rewardAmount;
    },
  });
};
